import { createQueryKeys } from '@lukemorales/query-key-factory';
import {
  BatchDetailResponse,
  EligibleItemsQuery,
  EligibleItemsResponse,
  ItemHistoryResponse,
  ListBatchesQuery,
  ListBatchesResponse,
  VerifyResponse,
  settlementDateAdjustmentApi,
} from '../../../lib/api/settlementDateAdjustment';

export const settlementDateAdjustmentQuery = createQueryKeys(
  'settlementDateAdjustment',
  {
    eligibleItems: (params: EligibleItemsQuery) => ({
      queryKey: [params],
      queryFn: (): Promise<EligibleItemsResponse> =>
        settlementDateAdjustmentApi.getEligibleItems(params),
    }),
    batches: (params: ListBatchesQuery) => ({
      queryKey: [params],
      queryFn: (): Promise<ListBatchesResponse> =>
        settlementDateAdjustmentApi.listBatches(params),
    }),
    batchDetail: (batchId: string) => ({
      queryKey: [batchId],
      queryFn: (): Promise<BatchDetailResponse> =>
        settlementDateAdjustmentApi.getBatchDetail(batchId),
    }),
    verify: (batchId: string) => ({
      queryKey: [batchId],
      queryFn: (): Promise<VerifyResponse> =>
        settlementDateAdjustmentApi.verify(batchId),
    }),
    itemHistory: (settlementItemId: number) => ({
      queryKey: [settlementItemId],
      queryFn: (): Promise<ItemHistoryResponse> =>
        settlementDateAdjustmentApi.getItemHistory(settlementItemId),
    }),
  },
);
